import { gql } from 'apollo-angular';

export const carModelInfoBrandsQuery = gql`
  query carModelInfoBrands {
    carModelInfoBrands
  }
`;

export const carModelInfoModelsQuery = gql`
  query carModelInfoModels($brand: String!) {
    carModelInfoModels(brand: $brand)
  }
`;

export const carModelInfoNamesQuery = gql`
  query carModelInfoNames($brand: String!, $model: String!) {
    carModelInfoNames(brand: $brand, model: $model)
  }
`;

export const carModelInfoQuery = gql`
  query carModelInfo($brand: String!, $model: String!, $name: String!) {
    carModelInfo(brand: $brand, model: $model, name: $name) {
      CO2EmissionNEDC
      CO2EmissionWLTP
      batteryCapacity
      brand
      cataloguePrice
      electricityConsumption
      enginePower
      euronorm
      fiscalHorsepower
      fuelConsumption
      fuelType
      fullName
      id
      mass
      model
      name
    }
  }
`;
